import { growthCountryFromTimeZone } from "./growthPacksFirst";

/**
 * Sent with payment.getCreditPacks and payment.createCreditPackCheckout. The
 * test itself lives on the server (server/packMemberPricing.ts): it holds the
 * prices and charges them. Only the browser knows the time zone that marks
 * growth_packs_first_v1's markets, which stay on list prices.
 */
export function creditPackPricingContext(): { growthMarket: boolean } {
  return { growthMarket: growthCountryFromTimeZone() !== null };
}

type PackPrices =
  | Record<string, { memberPrice?: number } | undefined>
  | null
  | undefined;

/**
 * True for the accounts paying the test's higher prices: the server sends
 * memberPrice only to them. List prices look the same in and out of the test,
 * so the other half can't be told apart here.
 */
export function isNonMemberPricing(packs: PackPrices): boolean {
  return Object.values(packs ?? {}).some(
    (pack) => pack?.memberPrice !== undefined,
  );
}

/** The upgrade modal's subtitle when the Studio opens it on the packs. */
export const TOP_UP_NO_PLAN_DESCRIPTION =
  "Add credits to your balance — no plan required.";
const TOP_UP_DESCRIPTION = "Add credits to your balance.";

/**
 * Accounts on the higher prices see "Plan members pay $30" on every card, so
 * they aren't also told that no plan is needed. Nobody sees that wording until
 * the prices have loaded, so it can't flash at an account about to see $36.
 */
export function upgradeModalDescription(
  description: string | undefined,
  packs: PackPrices,
): string | undefined {
  if (description !== TOP_UP_NO_PLAN_DESCRIPTION) return description;
  return packs && !isNonMemberPricing(packs) ? description : TOP_UP_DESCRIPTION;
}
